/* eslint-disable camelcase */
import { createContext, useContext } from 'react'
import { useTracking } from './context/selectors'

export const ComponentTrackingContext = createContext(() => {
  console.warn("You shouldn't reach here")
})

export const useComponentTracking = () => {
  return useContext(ComponentTrackingContext)
}

export const useTrackModule = props => {
  const { sys = {}, name, variant, moduleIndex, layout } = props
  const { id, contentTypeId: type } = sys
  const track = useTracking()

  const trackProps = {
    component_category: 'eevee-component',
    component_id: id,
    // type of module i.e. imageCalloutModule
    component_name: type,
    contentful_name: name,
    contentful_variant: variant,
    contentful_layout: layout,
    module_position_on_page: moduleIndex,
  }

  const trackComponent = (eventGrouping, eventName, eventData) => {
    const additionalTrackProps = { event_name: eventName }
    if (eventData) {
      for (const key in eventData) {
        if (typeof eventData[key] === 'object') {
          console.warn('Please do not nest objects in eventData as it is difficult to parse')
        }
      }
      additionalTrackProps.event_data = JSON.stringify(eventData)
    }

    return track(eventGrouping, { ...trackProps, ...additionalTrackProps })
  }

  return { trackComponent, trackProps }
}

/**
 * timeout
 *
 * Used when we want to wait for a tracking event to resolve,
 * and we don't want to block what happens after
 *
 * @param {Promise} p - promise which should resolve
 * @param {number} [ms] - (optional) number of ms before promise resolves
 * @returns {Promise} - which will resolve after a timeout
 */
export const timeout = (p, ms = 50) => Promise.race([willResolve(ms), p])

function willResolve(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
